// TODO : app.salesclue.io 배포 후 분기 문 처리해서 수정하기

const handleFreeBadgeLinkOpen = () => {
  if (window) {
    const hostname = window.location.hostname;

    if (
      hostname.includes('app.salesclue') ||
      hostname.includes('dev.salesclue.io')
    ) {
      window.open('https://app.salesclue.io', '_blank', 'noreferrer noopener');
      return;
    }
    window.open('https://www.salesclue.io', '_blank', 'noreferrer noopener');
  }
};

export default handleFreeBadgeLinkOpen;
